import React, { useEffect, useMemo } from 'react';
import projectsData from '../../../data/innerpages/single_project/defaultProject.json';

function Project({ projectData, projectIndex }) {
  // Find the correct project from the consolidated array
  const content = useMemo(() => {
    const projectId = projectIndex || projectData?.id || 1;
    return projectsData.find(p => p.id === projectId) || projectsData[0];
  }, [projectIndex, projectData]);

  useEffect(() => {
    // Initialize Swiper after component renders
    if (window.Swiper && projectData) {
      const swiperElems = document.querySelectorAll('.main-slider-img');
      swiperElems.forEach((el) => {
        // Check if Swiper is already initialized
        if (!el.swiper) {
          new window.Swiper(el, {
            loop: true,
            navigation: {
              nextEl: el.querySelector('.swiper-button-next'),
              prevEl: el.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: el.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        }
      });
    }
  }, [projectData]);
  
  if (!projectData) {
    return (
      <section className="tc-project-style1 header">
        <div className="main-info">
          <div className="container">
            <h1 className="title">Project not found</h1>
            <div className="text color-666 mt-30">
              Please select a project from the portfolio to view details.
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="tc-project-style1 header">
      <div className="main-info">
        <div className="container">
          <h1 className="title"> {content.name} </h1>
        </div>
      </div>
      <div className="description">
        <div className="container">
          <h3
            className="sub-title fsz-45 mb-60 wow fadeInUp slow"
            data-wow-delay="0.2s"
          >
            Description
          </h3>
          {content.description.paragraphs.map((paragraph, i) => (
            <div
              key={i}
              className="text fsz-24 mb-20 fw-500 wow fadeInUp slow"
              data-wow-delay="0.2s"
            >
              {paragraph}
            </div>
          ))}
        </div>
        <div className="imgs mt-120">
          <div className="container">
            <div className="row">
              {content.galleryImages.map((image, i) => (
                <div key={i} className="col-lg-6">
                  <div
                    className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow"
                    data-wow-delay={`${0.2 + i * 0.2}s`}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="img-cover"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="main-slider-img wow fadeInUp slow" data-wow-delay="0.2s">
        <div className="swiper-wrapper">
          {content.sliderImages.map((image, i) => (
            <div key={i} className="swiper-slide">
              <div className="img">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="img-cover"
                />
              </div>
            </div>
          ))}
        </div>
        <div className="arrows">
          <div className="swiper-button-prev"></div>
          <div className="swiper-pagination"></div>
          <div className="swiper-button-next"></div>
        </div>
      </div>
    </section>
  );
}

export default Project;
   